import { Area, AreaChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import type { SeriesPoint } from "../lib/api";
import { bucketLabel, nf } from "../lib/format";

export function SeriesChart({
  data,
  unit,
  tz,
}: {
  data: SeriesPoint[];
  unit: "hour" | "day";
  tz: string | undefined;
}) {
  const chartData = data.map((point) => ({ ...point, label: bucketLabel(point.ts, unit, tz) }));

  return (
    <div className="h-64 w-full">
      <ResponsiveContainer width="100%" height="100%">
        <AreaChart data={chartData} margin={{ top: 8, right: 8, left: 0, bottom: 0 }}>
          <defs>
            <linearGradient id="fillVisitors" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="#10b981" stopOpacity={0.25} />
              <stop offset="100%" stopColor="#10b981" stopOpacity={0} />
            </linearGradient>
            <linearGradient id="fillPageviews" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="#3b82f6" stopOpacity={0.2} />
              <stop offset="100%" stopColor="#3b82f6" stopOpacity={0} />
            </linearGradient>
          </defs>
          <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#e2e8f0" />
          <XAxis
            dataKey="label"
            tick={{ fontSize: 11, fill: "#94a3b8" }}
            tickLine={false}
            axisLine={false}
            minTickGap={28}
          />
          <YAxis
            tick={{ fontSize: 11, fill: "#94a3b8" }}
            tickLine={false}
            axisLine={false}
            width={36}
            allowDecimals={false}
          />
          <Tooltip
            formatter={(value, name) => [nf.format(Number(value)), name === "visitors" ? "Pengunjung" : "Pageview"]}
            labelStyle={{ fontSize: 12, color: "#334155" }}
            contentStyle={{ fontSize: 12, borderRadius: 8, border: "1px solid #e2e8f0" }}
          />
          <Area
            type="monotone"
            dataKey="visitors"
            name="visitors"
            stroke="#10b981"
            strokeWidth={2}
            fill="url(#fillVisitors)"
          />
          <Area
            type="monotone"
            dataKey="pageviews"
            name="pageviews"
            stroke="#3b82f6"
            strokeWidth={2}
            fill="url(#fillPageviews)"
          />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
}
